import React from "react";
import { motion, Variants } from "framer-motion";

interface NoResultsProps {
  title?: string;
  description?: string;
}

const containerVariants: Variants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0,
      ease: "easeOut" as const,
      when: "beforeChildren",
      staggerChildren: 0.2,
    },
  },
};

const childVariants: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: "easeOut" as const },
  },
};

const NoResults: React.FC<NoResultsProps> = ({
  title = "Sorry! No Result Found",
  description = "We did not find any items matching your search.",
}) => {
  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      className="text-center my-5"
    >
      <motion.svg
        width="80"
        height="80"
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        style={{ marginBottom: "20px" }}
        variants={childVariants}
      >
        {/* Main magnifier circle */}
        <circle cx="40" cy="40" r="25" stroke="#222" strokeWidth="4" fill="none" />
        {/* Handle */}
        <line x1="55" y1="55" x2="75" y2="75" stroke="#222" strokeWidth="4" />

        {/* Arc INSIDE the magnifier */}
        <motion.circle
          cx="40"
          cy="40"
          r="20"
          stroke="#1dbf73"
          strokeWidth="3"
          fill="none"
          strokeDasharray="31.4"
          strokeDashoffset="94.2"
          strokeLinecap="round"
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 1.5, ease: "linear" }}
          style={{
            originX: "40px",
            originY: "40px",
          }}
        />
      </motion.svg>

      <motion.h4 className="text-muted" variants={childVariants}>
        {title}
      </motion.h4>
      <motion.p className="text-secondary" variants={childVariants}>
        {description}
      </motion.p>
    </motion.div>
  );
};

export default NoResults;
